import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/finance/vendor-bills/$billId',
}).lazy(() => import('./vendor-bills.$billId.index.lazy').then((d) => d.Route))
